export default __webpack_public_path__ + "static/media/02_photo.5b5ec879.jpeg";